/* import __COLOCATED_TEMPLATE__ from './input-date.hbs'; */
import { computed } from '@ember/object';
import { isPresent } from '@ember/utils';
import { inject as service } from '@ember/service';
import Component from '@ember/component';
import FloatingDate from 'floating-date/utils/floating-date';
export default Component.extend({
  tagName: '',
  intl: service(),
  // Properties
  value: null,
  onChange() {},
  isDisabled: false,
  init(...args) {
    this._super(...args);

    // We need to *clone* the birthdate to ensure that the value
    // field can be rolled back.  This is a detail regarding Ember-Data.
    // with how it tracks changes and performs rollbacks.
    //
    // Otherwise, we'll just perform all our operations on the original object
    // and Ember-Data won't be able to track changes.
    const value = this.get('value');
    if (isPresent(value)) {
      this.set('_value', value.copy());
    } else {
      this.set('_value', FloatingDate.create());
    }
  },
  monthOptions: computed('intl', function () {
    return [...new Array(12)].map((value, index) => {
      return {
        value: index + 1,
        label: this.get('intl').t(`enums.months.short.${index + 1}`)
      };
    });
  }),
  monthId: computed('id', function () {
    if (isPresent(this.get('id'))) {
      return `${this.get('id')}--month`;
    }
    return null;
  }),
  dayId: computed('id', function () {
    if (isPresent(this.get('id'))) {
      return `${this.get('id')}--day`;
    }
    return null;
  }),
  yearId: computed('id', function () {
    if (isPresent(this.get('id'))) {
      return `${this.get('id')}--year`;
    }
    return null;
  }),
  actions: {
    // We only update it on did-change to prevent us from double-updating
    // prior to a render event.
    didChange(field, value) {
      const internalValue = this.get('_value');
      const parsedValue = Number.parseInt(value, 10); // base 10
      const safeValue = Number.isNaN(parsedValue) ? null : parsedValue;
      internalValue.set(field, safeValue);
      this.set('value', internalValue);
      this.onChange(internalValue);
    }
  },
  // Private
  // ====================

  // Set by `init`
  _value: null
});